import React from "react";
import { Notification, toast } from "components/ui";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";

// The API can return non-string messages (e.g. a Joi validation error's
// `details` array of {message, path, type, context} objects). Normalize
// to a string so React never gets a raw object/array as a child.
const toDisplayMessage = (message) => {
  if (typeof message === "string" || typeof message === "number") {
    return message;
  }
  if (Array.isArray(message)) {
    return (
      message
        .map((item) => (item && typeof item === "object" ? item.message : item))
        .filter(Boolean)
        .join(", ") || "Something went wrong. Please try again."
    );
  }
  if (message && typeof message === "object") {
    return message.message || "Something went wrong. Please try again.";
  }
  return "Something went wrong. Please try again.";
};

const OpenNotificationPopup = (type, message) => {
  // console.log("type, message : ", type, message);
  toast.push(
    <Notification
      type={type}
      duration={type === "success" ? 2000 : 3000}
      title={toDisplayMessage(message)}
      customIcon={
        type === "success" ? (
          <AiFillCheckCircle className="text-2xl" color="green" />
        ) : (
          <AiFillCloseCircle className="text-2xl" color="red" />
        )
      }
    />,
    {
      placement: "top-end",
    }
  );
};
export default OpenNotificationPopup;